import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Slide,
  Typography,
  useTheme,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { Close } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

interface Props {
  visible: boolean;
  content?: React.ReactNode;
  onClose?: () => void;
}

export const SourceModal = ({
  visible,
  content,
  onClose = () => {},
}: Props) => {
  const theme = useTheme();
  return (
    <Dialog
      fullWidth
      maxWidth={'sm'}
      open={visible}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
      scroll="body"
      TransitionComponent={Transition}
    >
      <DialogTitle
        sx={{
          bgcolor: theme.palette.primary.main,
          display: 'flex',
          alignItems: 'center',
          py: 2,
          position: 'relative',
        }}
        component="div"
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h6"
            component="span"
            textAlign="center"
            sx={{
              color: 'white',
            }}
          >
            Sources
          </Typography>
        </Box>

        <IconButton
          size="small"
          sx={{ ml: 'auto' }}
          edge="end"
          onClick={onClose}
        >
          <Close sx={{ fontSize: 'inherit', color: 'white' }} />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{ pt: '20px !important', pb: 2, maxHeight: 400, overflow: 'auto' }}
      >
        {content}
      </DialogContent>
      <Divider />
      <DialogContent sx={{ py: 1.5, textAlign: 'right' }}>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};
